import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "position-relative"
};
const _hoisted_2 = {
    key: 2,
    class: "container-sm"
};
const _hoisted_3 = { class: "col-md-12" };
const _hoisted_4 = {
    class: "row g-2 align-items-stretch product-list",
    style: { "overflow-y": "auto" }
};
const _hoisted_5 = ["product"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_loader = _resolveComponent("g-loader");
    const _component_g_product_record = _resolveComponent("g-product-record");
    const _component_v_horizontal = _resolveComponent("v-horizontal");
    const _component_g_product_card = _resolveComponent("g-product-card");
    return (_ctx.category.products && _ctx.category.products.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_ctx.isLoading)
                ? (_openBlock(), _createBlock(_component_g_loader, { key: 0 }))
                : _createCommentVNode("", true),
            (_ctx.mode === 'horizontal')
                ? (_openBlock(), _createBlock(_component_v_horizontal, {
                    key: 1,
                    ref: "accessories",
                    class: "horizontal w-100 h-100",
                    "container-class": "sh-2",
                    button: true
                }, {
                    default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.category.products, (item) => {
                            return (_openBlock(), _createBlock(_component_g_product_record, { product: item }, null, 8, ["product"]));
                        }), 256))
                    ]),
                    _: 1
                }, 512))
                : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.category.products, (product, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    key: product.itemNumber,
                                    product: product,
                                    class: "col-md-6 col-xl-4 d-flex align-items-stretch"
                                }, [
                                    _createVNode(_component_g_product_card, {
                                        product: product,
                                        options: _ctx.category.options
                                    }, null, 8, ["product", "options"])
                                ], 8, _hoisted_5));
                            }), 128))
                        ])
                    ])
                ]))
        ]))
        : _createCommentVNode("", true);
}
